import React from "react";
import { Box, Typography, Paper, useTheme } from "@mui/material";
import { FormattedMessage } from "react-intl";
import HTML from "bundles/common/components/HTML";

const CandidateSummaryBlock = ({ candidate }) => {
  const theme = useTheme();

  return (
    <>
      {candidate?.presentation && (
        <Paper sx={{ padding: "20px", marginTop: "20px", boxShadow: "none", borderRadius: "10px" }}>
          <Typography variant="h4" fontWeight={600} sx={{ color: theme.palette.secondary.black }}>
            <FormattedMessage id="candidate.presentation" defaultMessage="Candidate summary" />
          </Typography>
          <Box
            sx={{
              mt: "12px",
              fontSize: "12px",
              lineHeight: 1.55,
              fontWeight: 400,
              color: theme.palette.secondary.black,
              letterSpacing: "0.02em",
              fontFamily: "Segoe UI Regular, sans-serif",
              "& p": { margin: 0 },
              "& p + p": { marginTop: "0.65em" },
            }}
          >
            <HTML html={candidate.presentation} />
          </Box>
        </Paper>
      )}
    </>
  );
};

export default CandidateSummaryBlock;
